<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <div class="input-group">
    <span class="input-group-text">
      <i class="bx bx-calendar"></i>
    </span>
    <input
      #dateInput
      type="text"
      class="form-control"
      [class.is-invalid]="hasError"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [value]="value"
      (change)="handleNativeChange($event)"
      (blur)="onTouched()"
    />
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{
    helpText
  }}</small>

  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
